import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoutIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.06274 10.7398C8.06274 9.28044 9.19807 8.10001 10.5834 8.10001H18.9627C19.3229 8.10001 19.6213 8.40541 19.6213 8.79314C19.6213 9.18083 19.3229 9.48618 18.9627 9.48618H10.5834C9.91487 9.48618 9.3799 10.0519 9.3799 10.7398V28.2603C9.3799 28.9481 9.91481 29.5139 10.5834 29.5139H18.9627C19.3229 29.5139 19.6213 29.8193 19.6213 30.207C19.6213 30.5947 19.3229 30.9 18.9627 30.9H10.5834C9.19806 30.9 8.06274 29.7196 8.06274 28.2602V10.7398Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24.1502 13.095C23.8534 12.7878 23.3724 12.7913 23.0778 13.1033C22.7835 13.4149 22.7865 13.9168 23.0854 14.2244L27.43 18.7069H16.1697C15.7501 18.7069 15.4111 19.0613 15.4111 19.5C15.4111 19.9387 15.7501 20.2931 16.1697 20.2931H27.43L23.0855 24.7754C22.7869 25.0829 22.7842 25.5849 23.0778 25.8968C23.2268 26.0541 23.4224 26.1332 23.618 26.1332C23.8111 26.1332 24.0033 26.057 24.1502 25.905L29.811 20.0648C29.9553 19.9154 30.0372 19.7121 30.0372 19.4999C30.0372 19.2877 29.9563 19.0855 29.8109 18.9351L24.1502 13.095Z",
		fill: "currentColor"
	})]
});
export default SvgLogoutIcon;
